import {FaqItemBlock} from "@/lib/interfaces/blocks";

type FaqItemType = {
    block: FaqItemBlock
}
export default function FaqItem({block}: FaqItemType) {
    return (
        <details className="faq-section">
            <summary className="section-title">{block.content.question}</summary>
            <div className="section-content" dangerouslySetInnerHTML={{__html: block.content.answer}}></div>
        </details>
    )
}